<template>
  <div
    class="svg-container"
    v-html="require(`!html-loader!../../svg/${icon}.svg`)"
  />
</template>

<script>
function recursivelyRemoveFill(el) {
    if (!el) {
        return;
    }
    el.removeAttribute('fill');
    [].forEach.call(el.children, child => {
        recursivelyRemoveFill(child);
    });
}

// https://medium.com/js-dojo/making-svg-icon-component-in-vue-cb7fac70e758
export default {
    props: {
        icon: {
            type: String,
            default: null,
        },

        hasFill: {
            type: Boolean,
            default: false,
        },

        growByHeight: {
            type: Boolean,
            default: true,
        },
    },

    mounted() {
        if (this.$el.firstElementChild.nodeName === 'svg') {
            const svgElement = this.$el.firstElementChild;

            const viewBox = svgElement
                .getAttribute('viewBox')
                .split(' ')
                .map(n => Number(n));

            const widthToHeight = (viewBox[2] / viewBox[3]).toFixed(2);

            if (this.hasFill) {
                recursivelyRemoveFill(svgElement);
            }

            if (this.growByHeight) {
                svgElement.setAttribute('height', '1em');
                svgElement.setAttribute('width', `${widthToHeight}em`);
            } else {
                svgElement.setAttribute('width', '1em');
                svgElement.setAttribute('height', `${1 / widthToHeight}em`);
            }

            svgElement.classList.add('svg-class');
        }
    },
};
</script>

<style lang="scss" scoped>
.svg-container {
    display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/svg-icon.vue